import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { InfluencerStats } from "../Ecosystem/Influencer";
import { AffiliateEarnings } from "../../components/affiliate/AffiliateEarnings";
import { CREAM, DIM, GOLD, SANS, SERIF } from "../Ecosystem/sections";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });

const Earnings = ({ navigate, affiliate }) => (
  <div className="mt-14 rounded-3xl p-6" style={{ border: `1px solid ${GOLD}33`, background: "rgba(255,255,255,0.02)" }} data-testid="partner-area-earnings">
    <p className="text-[0.6rem] uppercase tracking-[0.28em]" style={{ color: GOLD, fontFamily: SANS }}>Earnings & statements</p>
    {affiliate ? (<>
      <div className="mt-4"><AffiliateEarnings /></div>
      <button type="button" onClick={() => navigate("/soulumo/affiliate-details")} data-testid="partner-area-tax-link"
        className="mt-5 text-sm underline underline-offset-4" style={{ color: CREAM, fontFamily: SANS }}>
        Tax & bank details for your payments
      </button>
    </>) : (
      <p className="mt-3 text-sm leading-relaxed" style={{ color: DIM, fontFamily: SANS }} data-testid="partner-area-earnings-pending">
        Your earnings, monthly statements and payment details will appear here once we switch on payouts for your account. We'll let you know personally.
      </p>
    )}
  </div>
);

// One place for a signed-in partner: clicks, ranking, starter kit, earnings and tax details.
export default function PartnerAreaPage() {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  useEffect(() => { axios.get(`${API}/api/partner/me`, auth()).then((r) => setMe(r.data)).catch(() => setMe({ is_partner: false })); }, []);
  if (!me) return <div className="flex min-h-screen items-center justify-center" style={{ background: "#070D0B" }}><Loader2 className="animate-spin" color={GOLD} /></div>;
  if (me.stats_token) return <InfluencerStats token={me.stats_token} extra={<Earnings navigate={navigate} affiliate={me.affiliate} />} />;
  return (
    <div className="min-h-screen px-6 py-24" style={{ background: "#070D0B", color: CREAM }} data-testid="partner-area-page">
      <div className="mx-auto max-w-2xl">
        <a href="/soulumo/account" className="mb-8 inline-block text-xs uppercase tracking-[0.24em]" style={{ color: DIM, fontFamily: SANS }} data-testid="partner-area-back">← Account</a>
        <h1 className="text-4xl font-light" style={{ fontFamily: SERIF, color: CREAM }}>Your partner area</h1>
        {me.is_partner ? <Earnings navigate={navigate} affiliate={me.affiliate} /> : (
          <p className="mt-6 text-base" style={{ color: DIM, fontFamily: SANS }} data-testid="partner-area-none">
            This account isn't linked to a partner link yet. If you're a Soulumo partner, ask us to link it to the email you sign in with.
          </p>
        )}
      </div>
    </div>
  );
}
